import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=cdcc8eda&scoped=true&"
import script from "./roleManagement.vue?vue&type=script&lang=js&"
export * from "./roleManagement.vue?vue&type=script&lang=js&"
import style0 from "./roleManagement.vue?vue&type=style&index=0&id=cdcc8eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcc8eda",
  null
  
)

export default component.exports